import React from 'react';

const Button = ({ data, type, icon, styles,onClick}) => {
  // Define classes based on the 'type' prop
  const buttonClasses = type === 'solid'
    ? 'bg-light-secondary text-white font-bold'
    : 'border border-light-secondary text-black-500 font-bold';

  return (
    <button className={`px-4 py-2 rounded flex whitespace-nowrap ${buttonClasses} ${styles}`} onClick={onClick}>
         {icon && (
        <span className="mr-2">
          <img src={icon} alt='icon' className='h-[20px] w-[20px]' />
        </span>
      )}
      {data}
    </button>
  );
};

export default Button;
